<template>
    <vue-snotify></vue-snotify>
</template>

<script>

import Lang from '../translations';

export default {

    computed: {
        flashError() {
            if (!this.$page.props.flash || !this.$page.props.flash.error) {
                return null;
            }

            return this.$page.props.flash.error;
        },
        flashErrors() {
            if (!this.$page.props.flash) {
                return [];
            }

            return this.$page.props.flash.errors || [];
        },
        flashSuccess() {
            if (!this.$page.props.flash || !this.$page.props.flash.success) {
                return null;
            }

            return this.$page.props.flash.success;
        },
    },

    methods: {
        handleErrors() {
            if (this.flashError) {
                this.$snotify.error(this.flashError);
            }
            if (this.flashSuccess) {
                this.$snotify.success(this.flashSuccess);
            }
        },
        handleFormErrors() {
            let errcount = Object.keys(this.flashErrors).length;
            if (errcount === 0) {
                return;
            }
            if (errcount === 1) {
                this.$snotify.error(Lang.get('snotify.flashmessages.one_error'));
            } else {
                this.$snotify.error(Lang.get('snotify.flashmessages.multiple_errors', {'%errcount%': errcount}));
            }
        },
    },

    name:"Flashmessages",

    watch: {
        '$page.props.flash': {
            handler() {
                this.handleErrors();
            },
            deep:true,
        },
        '$page.props.errors':{
            handler(){
                this.handleFormErrors();
            },
            deep:true,
        },
    }

}

</script>
